import { mutatorAction } from 'satcheljs';
import { PreviewInformation } from '../Schema/FilePreviewInformation';
import { getFilesPreviewInformationStore } from '../store/FilesPreviewInformationStore';

export const updateFilePreviewInformation = mutatorAction(
    'updateFilePreviewInformation',
    function updateFilePreviewInformation(
        fileId: string,
        previewInformation?: PreviewInformation,
        error?: Error
    ) {
        const filePreviewInfoStore = getFilesPreviewInformationStore();
        filePreviewInfoStore.fileInformation[fileId] = {
            previewInformation: previewInformation,
            error: error,
        };
    }
);
